import React from "react";
import { Toggle } from "react-powerplug";
import { Modal } from "@govlaunch/core";
import { useSlate, ReactEditor } from "slate-react";
import { Transforms } from "slate";
import Button from "../Button";
import SocialMediasInput from "../inputs/SocialMediasInput";
import EditSocialMediasIcon from "../icons/EditSocialMediasIcon";

export default function EditSocialMediasButton({ element }) {
  const editor = useSlate();
  const initialValues = element.socialMedias;

  return (
    <Toggle>
      {({ on, toggle }) => (
        <>
          <Modal
            isOpen={on}
            style={{
              boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
              borderRadius: 4,
            }}
            onRequestClose={() => toggle()}
            appElement={document.body}
          >
            <SocialMediasInput
              initialValues={initialValues.reduce((values, currentValue) => {
                return {
                  ...values,
                  [currentValue.socialMedia]: currentValue.url,
                };
              }, {})}
              onInsert={({ socialMedias }) => {
                const socialMediasNewProperties = {
                  socialMedias,
                };

                const elementPath = ReactEditor.findPath(editor, element);
                Transforms.setNodes(editor, socialMediasNewProperties, {
                  at: elementPath,
                });

                toggle();
              }}
            />
          </Modal>
          <Button
            onMouseDown={(event) => {
              event.preventDefault();
              // check for left click
              if (event.button === 0) {
                toggle();
              }
            }}
          >
            <EditSocialMediasIcon height="24px" width="24px" />
          </Button>
        </>
      )}
    </Toggle>
  );
}
